import { XCircle } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const REASONS: Record<string, string> = {
  consent_required: 'Consent was not granted. An administrator must approve the requested permissions.',
  consent_failed: 'We could not complete the connection. The request may have expired — please try again.',
  invalid_callback: 'The response from Microsoft was not valid. Please start the connection again.',
  internal_error: 'Something went wrong on our end. Please try again shortly.',
  access_denied: 'Consent was declined.',
};

/**
 * Shown when Azure AD admin consent fails or is declined. The `reason` query
 * param is set by the backend admin-consent callback.
 */
export function ConnectErrorPage() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') ?? 'consent_failed';
  const message = REASONS[reason] ?? 'The connection could not be completed. Please try again.';

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <XCircle className="mx-auto mb-4 h-12 w-12 text-destructive" />
          <CardTitle className="text-xl">Connection not completed</CardTitle>
          <CardDescription>{message}</CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <Link to="/connect" className="text-sm text-primary underline">
            Try again
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
